import createReducer from "../../createReducer";
import { hubspotPropertyHandlers } from "../handlers";
import { IHubspotPropertyState } from "../types";

export const updateHubspotProperty: IHubspotPropertyState = {
    isLoading: false,
    error: null,
    hubspotData: null,
    success: false,
    message: "",
};
export default createReducer(updateHubspotProperty, hubspotPropertyHandlers);
